import * as React from 'react';
import styled, { css } from 'styled-components';
import { forDesktop, forIE } from '@westwing/ui-kit/breakPoints';
import { useGaTracking } from './useTracking';
import HybridImage from 'Client/components/Generic/HybridImage';
import GenericHybridLink from 'Client/components/Generic/Links/HybridLink';
import { useBellaDispatch } from 'Client/redux/hooks';
import { BellaTestIds } from 'Common/qaIds';
import { setLDPKnownInfoAction } from 'Client/redux/lookDetail/actions';
import { Look } from 'Client/redux/productLooks/types';

const HybridLink = styled(GenericHybridLink)<{ isImageLoaded: boolean; borderColor: string }>`
    background: ${({ isImageLoaded, theme }) => `${isImageLoaded ? 'transparent' : theme.colors.charcoal3}`};

    picture {
        height: 100%;

        img {
            object-fit: cover;
            margin-left: 15px;
            margin-bottom: 15px;
            box-shadow: ${({ borderColor }) => `0 15px 0px 0px ${borderColor}, -15px 15px 0px 0px ${borderColor}`};
            width: calc(100% - 15px);
            height: calc(100% - 15px);

            ${({ borderColor }) =>
                css`
                    ${forDesktop`
                        margin-left: 20px;
                        margin-bottom: 20px;
                        box-shadow: 0 20px 0px 0px ${borderColor}, -20px 20px 0px 0px ${borderColor};
                        width: calc(100% - 20px);
                        height: calc(100% - 20px);
                    `}
                `}

            ${forIE`
                height: 485px;
                width: 385px;
            `}
        }
    }
`;

const FirstTile = ({ look, productSku }: { look: Look; productSku: string }) => {
    const [isImageLoaded, setImageLoaded] = React.useState(false);
    const dispatch = useBellaDispatch();

    const { trackLookInfusionClicks } = useGaTracking();

    if (!look || !look.portraitListingImage) {
        return null;
    }

    return (
        <HybridLink
            onClick={() => {
                dispatch(setLDPKnownInfoAction(look));
                trackLookInfusionClicks(`PDP: ${productSku}, Look image: ${look.trackingName}`);
            }}
            to={`/looks/${look?.slug}/`}
            borderColor={look?.color}
            isImageLoaded={isImageLoaded}
            testId={BellaTestIds.pdpLooksInfusionMoodImage}
        >
            <HybridImage
                mobileSrc={look?.portraitListingImage?.file.url}
                desktopSrc={look?.portraitListingImage?.file.url}
                fallbackSrc={look?.portraitListingImage?.file.url}
                alt={look?.portraitListingImage?.title}
                onLoad={() => setImageLoaded(true)}
            />
        </HybridLink>
    );
};

export default FirstTile;
